export default {
  Version: process.env.VUE_APP_VERSION,
};
